module.exports = __webpack_public_path__ + "static/media/OperatorIcon.21aceab6.png";